import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { Button, Modal, Select, Theme, ToggleButton } from '../../../components';
import { userActions, usersActions, userSelectors } from '../../../redux';
import { LanguageService } from '../../../services';

import './AddEditStore.scss';

interface Props {
  closeModal: () => void;
  isOpen: boolean;
  fromSideBar?: boolean;
}

const AppSettings: FC<Props> = ({ closeModal, isOpen, fromSideBar }) => {
  const dispatch = useDispatch();
  const { i18n, t } = useTranslation();
  const userInfo = useSelector(userSelectors.getUserInfo);
  const [activeCode, setActiveCode] = useState<string>(i18n.language);
  const [blinkTimer, setBlinkTimer] = useState<boolean>(userInfo.blinkTimer);

  const save = async () => {
    LanguageService.setLanguage(activeCode);
    await dispatch(usersActions.editUser(userInfo.id, { blinkTimer }));
    dispatch(userActions.getUserInfo());
    closeModal();
  };

  useEffect(() => {
    setActiveCode(i18n.language);
  }, [i18n.language]);

  return (
    <Modal title={t('titleSettings')} isOpen={isOpen} closeModal={() => closeModal()}>
      <div className='add-edit-container'>
        <div className='country'>
          <span>{t('lblCountry')}</span>
          <p>{userInfo.country.name}</p>
        </div>

        <Select
          label='lblLanguage'
          placeholder='phLanguage'
          options={userInfo.languages.map(({ language, code }) => ({
            value: code,
            label: language,
          }))}
          onChange={(languageCode: string) => setActiveCode(languageCode)}
          value={activeCode}
        />

        {!fromSideBar && (
          <ToggleButton inverted label={t('lblTimerSetting')} isChecked={blinkTimer} onClick={() => setBlinkTimer(!blinkTimer)} />
        )}

        <div className='buttons'>
          <Button theme={Theme.INVERSE} onClickCallback={closeModal}>
            {t('lblCancel')}
          </Button>
          <Button
            theme={Theme.SECONDARY}
            onClickCallback={save}
            isDisabled={activeCode === i18n.language && blinkTimer === userInfo.blinkTimer}>
            {t('lblSave')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default AppSettings;
